import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { defaultFilters, FilterObject } from '@app/library/models/filters.model';
import {
  ResetFilterForBacCurrentlyEditing,
  SetFilterForBacCurrentlyEditing,
} from '@app/library/states/filters.actions';
import { FiltersState } from '@app/library/states/filters.state';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Select } from '@ngxs/store';
import { CloseCurrentPanel, DynamicEnabledPanel } from '@radioking/shared/pannel-manager';
import amplitude from 'amplitude-js';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'rk-library-filter-panel',
  templateUrl: './library-filter-panel.component.html',
  styleUrls: ['./library-filter-panel.component.scss'],
})
export class LibraryFilterPanelComponent
  implements OnInit, DynamicEnabledPanel, OnDestroy
{
  @Select(FiltersState.getCurrentEditingBacId)
  bacId$: Observable<number>;

  formFilters: UntypedFormGroup;

  @Select(FiltersState.getFilterOfCurrentEditing)
  currentFilterValue$: Observable<FilterObject>;

  subscription = new Subscription();

  constructor(private readonly fb: UntypedFormBuilder) {}

  ngOnInit() {
    this.formFilters = this.fb.group({
      bpm: [{}],
      bitrate: [{}],
      year: [{}],
      playtime: [{}],
      createdDays: [{}],
      inPlaylist: [{}],
      tags: [{}],
    });

    this.formFilters.setValue(defaultFilters);

    const subs = this.currentFilterValue$.pipe(filter(val => !!val)).subscribe(val => {
      const finalObj = { ...defaultFilters };
      Object.keys(val).map(key => {
        finalObj[key] = val[key];

        return key;
      });
      this.formFilters.setValue(finalObj);
    });
    this.subscription.add(subs);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  hasToShowConfirmOnExit(): boolean {
    return false;
  }

  isDirty(): boolean {
    return false;
  }

  @Dispatch()
  exitPanel = () => new CloseCurrentPanel(true);

  @Dispatch()
  resetToDefault = () => [
    new ResetFilterForBacCurrentlyEditing(),
    new CloseCurrentPanel(true),
  ];

  @Dispatch()
  saveForm = () => {
    amplitude.getInstance().logEvent('apply_filters');
    const finalObj = this.formFilters.getRawValue();

    return [new SetFilterForBacCurrentlyEditing(finalObj), new CloseCurrentPanel(true)];
  };
}
